module.exports = __webpack_public_path__ + "static/img/大数据.21fa743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/大数据.jpg
// module id = OXQp
// module chunks = 1